export enum FeatureTypes {}

const features: Record<FeatureTypes, boolean> = {};

export const isFeatureEnabled = (feature: FeatureTypes) => {
    return features[feature];
};
